import React from 'react';
import { useTranslation } from 'react-i18next';
import Title from '../../../components/common/title';
import InfoBlockStatic from '../../../components/common/info-block/static';
import { route } from '../../../services/utils';
import { SYSTEM_FILE } from '../../../router/routes';
import { SystemConfiguration } from '../../../enums/system-configuration';

export default function BiologicalFarmingReport() {
  const { t } = useTranslation();

  const lawUrl = "https://likumi.lv/ta/id/193115-biologiskas-lauksaimniecibas-uzraudzibas-un-kontroles-kartiba";

  const xlsFileName = "Pārskats_par_saražoto_produkciju.xls";

  const xlsFileLink =
    <u>
      <a
          target="_blank"
          rel="noopener noreferrer"
          href={route(SYSTEM_FILE, {
            systemCfgKey: SystemConfiguration.BIOLOGICAL_FARMING_REPORT_XLS,
          })}
        >
          {xlsFileName}
      </a>
    </u>;

  return (
    <>
      <Title title={t('pages.reports.biological-farming.title')} />

      <InfoBlockStatic
        text={
          <>
            <p>Bioloģiskajiem lauksaimniekiem (operatoriem)  katru gadu līdz 1.februārim bioloģiskās lauksaimniecības kontroles institūcijās jāiesniedz Pārskats par bioloģisko saimniecību, iekļaujot informāciju par iepriekšējā gadā bioloģiskās lauksaimniecības kontrolei pakļauto platību, audzētajām kultūrām, augu un dzīvnieku izcelsmes produkciju, saražotās, pārstrādātās un izlietotās produkcijas veidu un apjomu atbilstoši MK noteikumu Nr. 485 "Bioloģiskās lauksaimniecības uzraudzības un kontroles kārtība" (26.05.2009) 2. vai 2.1 pielikumam, un informāciju par saražotās produkcijas atlikumu iepriekšējā gada 31.decembrī.</p>
            <p>Lai sagatavotu prasīto informāciju, lejupielādē zemāk redzamo pielikumu "{xlsFileLink}", aizpildi to, paraksti to (ar e-parakstu) un nosūti bioloģiskās lauksaimniecības kontroles institūcijai, kurā esi iesniedzis iesniegumu par iekļaušanu bioloģiskās lauksaimniecības kontroles sistēmā.</p>
            <p>Ja neizmanto e-parakstu, vari veidlapu izdrukāt un parakstīt ar roku, pēc tam nosūtot kontroles institūcijai pa pastu:</p>
            <ul>
              <li>Sertifikācijas institūcija "Vides kvalitāte"; E-pasts: <u><a href="mailto:info@videskvalitate.lv">info@videskvalitate.lv</a></u>, adrese: Rīgas iela 113, Salaspils, Salaspils novads, LV-2169.</li>
              <li>SIA "Sertifikācijas un testēšanas centrs"; E-pasts: <u><a href="mailto:info@stc.lv">info@stc.lv</a></u>; adrese: Dārza iela 12, Priekuļi, Priekuļu pagasts, Priekuļu novads, LV-4126.</li>
              <li>SIA "Sertifikācijas centrs"; E-pasts: <u><a href="mailto:bio@persc.lv">bio@persc.lv</a></u>, adrese: Pļavas iela 3A, Cēsis, Cēsu novads, LV-4101.</li>
            </ul>
            <p>MK noteikumus skatīt <u><a href={lawUrl} target='_blank' rel='noopener noreferrer'>ŠEIT</a></u> (<a href={lawUrl} target='_blank' rel='noopener noreferrer'>{lawUrl}</a>) </p>
            <br />
            <br />
            <strong>{xlsFileLink}</strong>
          </>
        }
      />
    </>
  );
}
